import { FC, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Button, Headline, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { ApiReportTemplateStatusChoices } from "@api/graphql/types-and-hooks";
import { TemplatesTable } from "@components/TemplatesTable/TemplatesTable";
import { CreateTemplateDialog } from "@routes/Templates/CreateTemplateDialog";

enum TemplatesTab {
  Active = "Active",
  Archived = "Archived",
}

const Templates: FC = () => {
  const [currentTab, setCurrentTab] = useState<TemplatesTab>(TemplatesTab.Active);
  const tabs = [TemplatesTab.Active, TemplatesTab.Archived];
  const [isNewTemplateDialogOpen, setIsNewTemplateDialogOpen] = useState<boolean>(false);
  const { pathname } = useLocation();
  const shouldMatchWithUrl = `/templates`;

  return (
    <div className="mx-auto flex w-full flex-col content-between items-center lg:flex-col lg:items-start">
      <div className="mt-10 flex w-full items-center justify-between">
        {pathname === shouldMatchWithUrl ? (
          <>
            <Headline size="medium">Templates</Headline>
            <div className="flex items-center space-x-2">
              <Button
                text="New Template"
                appearance="primary"
                className="rounded-sm"
                onClick={() => {
                  setIsNewTemplateDialogOpen(true);
                }}
              />
            </div>
          </>
        ) : null}
      </div>
      {pathname === shouldMatchWithUrl ? (
        <div className="w-full">
          <TabNavigation
            tabs={tabs.map((tabName) => ({
              name: tabName,
              type: "component",
              current: currentTab === tabName,
              Component: (
                <Button
                  text={tabName}
                  appearance="text"
                  className={`hover:text-primary ${currentTab === tabName ? "text-limestone-900" : "text-text-secondary"}`}
                  onClick={() => setCurrentTab(tabName)}
                />
              ),
            }))}
          />
          {currentTab === TemplatesTab.Active ? (
            <TemplatesTable
              key="active-templates-table"
              statuses={[ApiReportTemplateStatusChoices.Draft, ApiReportTemplateStatusChoices.Published]}
            />
          ) : (
            <TemplatesTable key="archived-templates-table" statuses={[ApiReportTemplateStatusChoices.Archived]} />
          )}
        </div>
      ) : (
        <Outlet />
      )}
      <CreateTemplateDialog isDialogOpen={isNewTemplateDialogOpen} setDialogOpen={setIsNewTemplateDialogOpen} />
    </div>
  );
};

export default Templates;
